// extracted by mini-css-extract-plugin
export default {"actionDropdown":"jobDropdown_actionDropdown__3ATb2","settingsIcon":"jobDropdown_settingsIcon__9BBRN","settingsIconActive":"jobDropdown_settingsIconActive__MciCs"};